import { useLandingPagePaths } from '~hooks/useLandingPagePaths';

import type { ContentfulComponentLink } from './types';

/** Generates the correct `href` for the Contentful link component whether it's an explicit value or a page reference. */
export const useHref = (link: ContentfulComponentLink): string => {
  const landingPagePaths = useLandingPagePaths();
  const pageId = link.page?.id;
  if (pageId && landingPagePaths[pageId]) return landingPagePaths[pageId].path;
  return link.to || '/';
};
